/**
 * Выключатель на чертеже: одно-, двух-, трёхклавишный — любой из каталога.
 *
 * Подложка чуть сильнее скруглена, чем у розетки, и с тонкой обводкой в цвет
 * типа: на плане выключатели и розетки должны различаться с одного взгляда,
 * даже когда символ внутри уже не разглядеть.
 */
import { CatalogSymbol } from "../../CatalogSymbol";
import type { ElementShapeProps } from "./ElectricalItemShape";
import { ItemFrame, SELECTED_COLOR } from "./ItemFrame";

export const SwitchShape = ({
	fixture,
	item,
	width,
	height,
	color,
	selected,
	...frame
}: ElementShapeProps) => {
	const px = (n: number) => n * frame.mmPerPx;
	const stroke = selected ? SELECTED_COLOR : color;
	return (
		<ItemFrame
			{...frame}
			fixtureId={fixture.id}
			width={width}
			height={height}
			color={color}
			selected={selected}
			backdrop={
				<rect
					x={-width / 2}
					y={-height / 2}
					width={width}
					height={height}
					rx={Math.min(width, height) * 0.22}
					fill="#ffffff"
					stroke={stroke}
					strokeWidth={px(1.1)}
				/>
			}
		>
			<CatalogSymbol
				item={item}
				width={width}
				height={height}
				color={stroke}
				mmPerPx={frame.mmPerPx}
			/>
		</ItemFrame>
	);
};
